define('views/pages/dashboard/index',['require','jquery','views/base/page','views/pages/dashboard/news','views/pages/dashboard/balance','views/pages/dashboard/notifies','views/pages/dashboard/sessions','text!templates/pages/dashboard/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        PageView = require('views/base/page'),
        NewsPanelView = require('views/pages/dashboard/news'),
        BalancePanelView = require('views/pages/dashboard/balance'),
        NotifiesPanelView = require('views/pages/dashboard/notifies'),
        SessionsPanelView = require('views/pages/dashboard/sessions'),
        template = require('text!templates/pages/dashboard/index.ejs');

    var DashboardPageView = PageView.extend({
        autoRender: true,
        template: template,
        id: 'pages-dashboard-page',
        regions: {
            'dashboard-news': '#dashboard-news-container',
            'dashboard-balance': '#dashboard-balance-container',
            'dashboard-notifies': '#dashboard-notifies-container',
            'dashboard-sessions': '#dashboard-sessions-container'
        },
        listen: {
            'addedToDOM': 'onAddedToDOM',
            'resize model': 'onResize',
            'afterLoad model': 'onResize'
        },
        windowResize: true,
        onAddedToDOM: function() {
            this.model.trigger('resize');
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('dashboard-balance', new BalancePanelView({ model: this.model.balance, region: 'dashboard-balance' }));
            this.subview('dashboard-news', new NewsPanelView({ model: this.model.news, region: 'dashboard-news' }));
            this.subview('dashboard-notifies', new NotifiesPanelView({ model: this.model.notifies, region: 'dashboard-notifies' }));
            this.subview('dashboard-sessions', new SessionsPanelView({ model: this.model.sessions, region: 'dashboard-sessions' }));
        },
        onResize: function() {
            var h = $('body').height();
            var t = this.$el.position().top;
            this.$el.height(h - t - 20);

            this.model.notifies.trigger('resize');
        }
    });

    return DashboardPageView;
});

